module.exports = __webpack_public_path__ + "static/nurat-48aebeaf998f09d046fa802e3bf289ce.jpg";